module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"snackText":"Database updated!","avertissement":"This app is in development. Please save your library regularly (Save -> export)"},"fr":{"snackText":"Base de données mise à jour !","avertissement":"Cette app est en cours de développement. Il est recommandé de sauvegarder vos données régulièrement (Sauvegarde -> exporter)"}}')
  delete Component.options._Ctor
}
